import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../contexts/UserContext';
import ToastNotification from '../customBronson/toastNotification';
import '../../css/huerto/scoring.css';
import { withRouter } from 'react-router-dom';
import ContractsService from '../../../services/ContractsService';
import { withCookies } from 'react-cookie';
import Loading from '../../bronson/Loading';
import Globals from '../../../Globals';
import CanalsAdapter from '../../bronson/DealershipFullComponent';
import ScoringTable from './scoringTable';
import FunctionGeneral from './functionsGeneral';

const BaseUrlForDealerships =
    Globals.BFF_PATH.BASE_URL + '/DealerService/getremarketingdealerships';
const convertFechaPrint = data_Temp => {
    for (let element in data_Temp) {
        if (data_Temp[element]['ExpirationDate'])
            data_Temp[element]['ExpirationDate'] =
                new FunctionGeneral().formatFecha(
                    data_Temp[element]['ExpirationDate']
                        .split('T')[0]
                        .split('-')
                );

        if (data_Temp[element]['IPODate'])
            data_Temp[element]['IPODate'] = new FunctionGeneral().formatFecha(
                data_Temp[element]['IPODate'].split('T')[0].split('-')
            );
    }
    return data_Temp;
};
const contractColors = 'AA,CA,BA,AB,BB,CB,CC,BC,AC';

const downloadExcelFile = model => {
    var sliceSize = 2000;
    var byteCharacters = window.atob(model.Data);
    var byteArrays = [];

    for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
    ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: model.FileType });
    var fileURL = URL.createObjectURL(blob);
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = fileURL;
    a.download = model.Name;
    a.click();
    window.URL.revokeObjectURL(fileURL);
    a.remove();
};

const Scoring = ({ cookies, history }) => {
    const [loading, setLoading] = useState(false);
    const [dataTodosLosVencimientos, setDataTodosLosVencimientos] = useState(
        []
    );
    const [dataVencimientosAsignados, setDataVencimientosAsignados] = useState(
        []
    );
    const [scoringTable, setScoringTable] = useState(false); //si muestra la vista de la tabla o no
    const [dealerCodeVWF, setDealerCodeVWF] = useState('');
    const [formData, setFromData] = useState(null);
    const { user } = useContext(UserContext);
    const [parametrosLanding, setParametrosLanding] = useState(getTextoLandig); //texto landig modificable por negocios
    const [optSelectMarca, setOptSelectMarca] = useState([]); //lista de marcas posibles en el concesionario seleccionado
    const [optSelectMarcaCargaDatos, setoptSelectMarcaCargaDatos] =
        useState(false); // solo se cargan las marcas posibles al cambiar de consecionario, evitando que al aplicar los filtros solo salgan las marcas entre los contratos retornados
    const [showToast, setShowToast] = useState(false);
    const [matrixData, setMatrixData] = useState([]);
    const [matrixContracts, setMatrixContracts] = useState('');
    const [filtersApplied, setFiltersApplied] = useState([]);
    const [titleText, setTitleText] = useState('');
    const [contratosAsignados, setContratosAsignados] = useState(0);
    const [showDownloadError, setShowDownloadError] = useState(false);
    const [downloadErrorMessage, setDownloadErrorMessage] = useState('');
    const downloadTimeoutRef = React.useRef(null);
    const downloadErrorTimeoutRef = React.useRef(null);

    useEffect(() => {
        const _formData = {
            idCliente: cookies.get(Globals.COOKIES.USER),
            dealership: {
                flex: '1/1',
                onChange: value => beforeChange(value, setDealerCodeVWF),
                baseURL: BaseUrlForDealerships,
                withTitle: false,
                defaultValue: dealerCodeVWF != '' ? dealerCodeVWF : '0000',
                token: cookies.get(Globals.COOKIES.JWT).AccessToken,
            },
        };
        setFromData(_formData);
        setDealerSelected();
        setoptSelectMarcaCargaDatos(true);
        InitialMatrixData();
        setMatrixContracts('');
        setFiltersApplied([]);
        if (dealerCodeVWF !== '' && user.data.Profile === 12)
            getTableDataAsignados(dealerCodeVWF, user.data.UserId);
    }, [dealerCodeVWF]);

    useEffect(() => {
        if (user.data.Dealers.length === 1) {
            const _formData = {
                idCliente: cookies.get(Globals.COOKIES.USER),
                dealership: {
                    flex: '1/1',
                    onChange: value => beforeChange(value, setDealerCodeVWF),
                    baseURL: BaseUrlForDealerships,
                    withTitle: false,
                    defaultValue: user.data.Dealers[0].VWFCode,
                    token: cookies.get(Globals.COOKIES.JWT).AccessToken,
                },
            };
            setFromData(_formData);
        } else {
            const _formData = {
                idCliente: cookies.get(Globals.COOKIES.USER),
                dealership: {
                    flex: '1/1',
                    onChange: value => beforeChange(value, setDealerCodeVWF),
                    baseURL: BaseUrlForDealerships,
                    withTitle: false,
                    defaultValue:
                        history != undefined &&
                        history.location.state != null &&
                        history.location.state.dealerCodeVWF != null
                            ? history.location.state.dealerCodeVWF
                            : '0000',
                    token: cookies.get(Globals.COOKIES.JWT).AccessToken,
                },
            };
            setFromData(_formData);
        }
    }, [user]);

    useEffect(() => {
        var _contratosAsignados = 0;
        if (optSelectMarcaCargaDatos) {
            let optMarca = [];
            if (dataTodosLosVencimientos.length > 0) {
                dataTodosLosVencimientos.forEach(element => {
                    optMarca.push([
                        element.BrandDescription.trim(),
                        element.BrandCode.trim(),
                    ]);
                    if (element.VendedorAsignado !== null)
                        _contratosAsignados++;
                });
                optMarca = new FunctionGeneral().reemplazarDuplicados(optMarca);
            }
            setOptSelectMarca(optMarca);
            setoptSelectMarcaCargaDatos(false);
            setContratosAsignados(_contratosAsignados);
        } else {
            dataTodosLosVencimientos.forEach(element => {
                if (element.VendedorAsignado !== null) _contratosAsignados++;
            });
            setContratosAsignados(_contratosAsignados);
        }
    }, [dataTodosLosVencimientos]);

    useEffect(() => {
        if (!optSelectMarcaCargaDatos)
            getTableData(
                matrixContracts !== '' ? matrixContracts : contractColors,
                filtersApplied
            );
    }, [filtersApplied, matrixContracts]);

    async function exportVencimientosExcel({
        viewDataVencimientoAsignado,
        orden,
        filterAsignados,
        filtermatriculAsignados,
    }) {
        let didTimeout = false;

        try {
            setLoading(true);

            // Timeout de 30 segundos
            downloadTimeoutRef.current = setTimeout(() => {
                didTimeout = true;
                setLoading(false);
                setDownloadErrorMessage(
                    'La descarga esta tardando demasiado. Por favor, intente nuevamente.'
                );
                setShowDownloadError(true);
                if (downloadErrorTimeoutRef.current) {
                    clearTimeout(downloadErrorTimeoutRef.current);
                }
                downloadErrorTimeoutRef.current = setTimeout(() => {
                    setShowDownloadError(false);
                }, 5000);
            }, 30000);

            const token = cookies.get(Globals.COOKIES.JWT).AccessToken;
            let response;

            if (viewDataVencimientoAsignado) {
                response =
                    await new ContractsService().readRentingExpirationListExcel(
                        token,
                        dealerCodeVWF,
                        matrixContracts !== '' ? matrixContracts : contractColors,
                        filtersApplied,
                        {
                            OrderType:
                                orden && orden.length === 2 ? orden[0] : '',
                            OrderField:
                                orden && orden.length === 2 ? orden[1] : '',
                            FilterAsignados: filterAsignados,
                        }
                    );
            } else {
                response =
                    await new ContractsService().readRentingExpirationListAsignadosExcel(
                        token,
                        dealerCodeVWF,
                        user.data.UserId,
                        {
                            OrderType:
                                orden && orden.length === 2 ? orden[0] : '',
                            OrderField:
                                orden && orden.length === 2 ? orden[1] : '',
                            VehiclePlate: filtermatriculAsignados,
                        }
                    );
            }

            // Limpiar timeout si completó correctamente
            if (downloadTimeoutRef.current) {
                clearTimeout(downloadTimeoutRef.current);
            }

            if (didTimeout) {
                return false;
            }

            if (!response || !response.body) {
                setLoading(false);
                setDownloadErrorMessage('Error en la respuesta del servidor. Por favor, intente nuevamente.');
                setShowDownloadError(true);
                if (downloadErrorTimeoutRef.current) {
                    clearTimeout(downloadErrorTimeoutRef.current);
                }
                downloadErrorTimeoutRef.current = setTimeout(() => {
                    setShowDownloadError(false);
                }, 5000);
                return false;
            }

            var model = JSON.parse(JSON.parse(response.body).Result);
            if (!model || !model.Data) {
                setLoading(false);
                setDownloadErrorMessage('El archivo no contiene datos validos. Por favor, intente nuevamente.');
                setShowDownloadError(true);
                if (downloadErrorTimeoutRef.current) {
                    clearTimeout(downloadErrorTimeoutRef.current);
                }
                downloadErrorTimeoutRef.current = setTimeout(() => {
                    setShowDownloadError(false);
                }, 5000);
                return false;
            }

            downloadExcelFile(model);
            setLoading(false);
            return true;
        } catch (error) {
            if (downloadTimeoutRef.current) {
                clearTimeout(downloadTimeoutRef.current);
            }
            setLoading(false);
            setDownloadErrorMessage('Error al descargar el fichero. Por favor, intente nuevamente.');
            setShowDownloadError(true);
            if (downloadErrorTimeoutRef.current) {
                clearTimeout(downloadErrorTimeoutRef.current);
            }
            downloadErrorTimeoutRef.current = setTimeout(() => {
                setShowDownloadError(false);
            }, 5000);
            return false;
        }
    }

    async function getTextoLandig() {
        var _response = await new ContractsService().getTextoLanding(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            if (response.length > 0)
                if (response[0].TPCVALORCONSTANTE !== '') {
                    setShowToast(true);
                    setTimeout(() => {
                        setShowToast(false);
                    }, 5000); //cerramos modal de notificacion luego de 5 seg por defecto
                }

            setParametrosLanding(response);
        }
    }

    async function InitialMatrixData() {
        if (
            dealerCodeVWF !== null &&
            dealerCodeVWF !== undefined &&
            dealerCodeVWF !== ''
        ) {
            var requestData = await new ContractsService().readScoringMatrix(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                dealerCodeVWF
            );
            if (
                requestData &&
                requestData.statusCode === 200 &&
                requestData.body &&
                requestData.body.Result
            ) {
                var data = JSON.parse(requestData.body.Result);
                if (data !== null && data !== undefined && data.length > 0)
                    setMatrixData(data);
                else {
                    setMatrixData(initMatrix());
                }
            }
        }
    }

    async function getTableDataAsignados(dealerCodeVWF, user, num) {
        var dataTableAsignados =
            await new ContractsService().readRentingExpirationListAsignados(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                dealerCodeVWF,
                user
            );

        if (
            dataTableAsignados &&
            dataTableAsignados.statusCode === 200 &&
            dataTableAsignados.body &&
            dataTableAsignados.body.Result
        ) {
            var data_Asignados = JSON.parse(dataTableAsignados.body.Result);
            if (data_Asignados !== null && data_Asignados !== undefined) {
                //  setLoading(false);
                if (data_Asignados.length > 0) {
                    setDataVencimientosAsignados(
                        convertFechaPrint(data_Asignados)
                    );
                } else {
                    setDataVencimientosAsignados(convertFechaPrint([]));
                }
            } else {
                if (num !== 1) {
                    if (num !== 0)
                        await getTableDataAsignados(dealerCodeVWF, user, 0);
                    else await getTableDataAsignados(dealerCodeVWF, user, 1);
                }
                console.log('error data table asignados: ' + num);
            }
        }
    }

    async function getTableData(matrixContracts, filtersApplied, num) {
        if (
            dealerCodeVWF !== null &&
            dealerCodeVWF !== undefined &&
            dealerCodeVWF !== ''
        ) {
            setLoading(true);
            var dataTable =
                await new ContractsService().readRentingExpirationList(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    dealerCodeVWF,
                    matrixContracts,
                    filtersApplied
                );

            if (
                dataTable &&
                dataTable.statusCode === 200 &&
                dataTable.body &&
                dataTable.body.Result
            ) {
                var data = JSON.parse(dataTable.body.Result);
                if (data !== null && data !== undefined) {
                    setLoading(false);
                    if (data.length > 0) {
                        setDataTodosLosVencimientos(convertFechaPrint(data));
                    } else {
                        setDataTodosLosVencimientos(convertFechaPrint([]));
                    }
                }
            } else {
                if (num !== 1) {
                    if (num !== 0)
                        await getTableData(matrixContracts, filtersApplied, 0);
                    else await getTableData(matrixContracts, filtersApplied, 1);
                } else setLoading(false);

                console.log('error data table: ' + num);
            }
        }
    }

    const initMatrix = () => {
        var initData = [
            { Category: 'AA', Amount: 0 },
            { Category: 'AB', Amount: 0 },
            { Category: 'AC', Amount: 0 },
            { Category: 'AR', Amount: 0 },
            { Category: 'BA', Amount: 0 },
            { Category: 'BB', Amount: 0 },
            { Category: 'BR', Amount: 0 },
            { Category: 'BC', Amount: 0 },
            { Category: 'CA', Amount: 0 },
        ];
        return initData;
    };
    const beforeChange = (value, setState) => {
        setState(value);
        setDealerCodeVWF(value);
    };

    const setDealerSelected = async () => {
        if (dealerCodeVWF !== '') {
            setLoading(true);
            getTableData(contractColors, []);
            setScoringTable(true);
        }
    };

    const getToastNotification = () => {
        if (showToast && parametrosLanding.length > 0)
            return (
                <div id="ToastNotificationHuerto">
                    <ToastNotification
                        title={'Importante!'}
                        text={
                            'Importante!:  ' +
                            parametrosLanding[0].TPCVALORCONSTANTE
                        }
                        closeText={'Importante!'}
                        type={'warning'}
                        showToast={showToast}
                        setShowToast={setShowToast}
                    />
                </div>
            );
    };

    const getDownloadErrorNotification = () => {
        if (showDownloadError)
            return (
                <div id="ToastNotificationDownloadError">
                    <ToastNotification
                        title={'Error'}
                        text={downloadErrorMessage}
                        closeText={'Cerrar'}
                        type={'error'}
                        showToast={showDownloadError}
                        setShowToast={setShowDownloadError}
                    />
                </div>
            );
    };

    return (
        <React.Fragment>
            <Loading ariaBusy={loading}></Loading>
            <div className="o-page-wrap--xsmall">
                {getToastNotification()}
                {getDownloadErrorNotification()}
                <div className="o-component-wrapper">
                    <div className=" o-layout--equal-height scoring-parent-div">
                        <div
                            className="o-layout"
                            style={{ marginBottom: '20px' }}
                        >
                            <div id="SelectConce">
                                <div className="o-layout__item  u-2/3">
                                    {titleText !== '' && (
                                        <div style={{ marginBottom: '15px' }}>
                                            <h1 className="u-h1">
                                                {titleText}
                                            </h1>
                                        </div>
                                    )}
                                    <div className="u-text-capitalize">
                                        <h3 className="u-text-left u-h4">
                                            hola {user.data.Name},
                                        </h3>
                                    </div>
                                    <div>
                                        <label className="u-h4">
                                            Selecciona un concesionario
                                        </label>
                                        {formData !== null &&
                                        formData.dealership.baseURL != null &&
                                        formData.idCliente != null ? (
                                            <div
                                                className="o-layout"
                                                style={{
                                                    maxWidth: '300px',
                                                    marginTop: '0px',
                                                }}
                                            >
                                                <CanalsAdapter {...formData} />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div
                                    className="o-layout__item  u-1/3 u-mt-xlarge"
                                    id="DistribucionAsignados"
                                    style={{ display: 'none' }}
                                >
                                    <div className="u-1/1 u-h4">
                                        Distribucion de Contratos Asignados
                                    </div>
                                    <div className="u-1/1 u-h5">
                                        {contratosAsignados} asignados
                                    </div>
                                    <div className="u-1/1 u-h5">
                                        {dataTodosLosVencimientos.length -
                                            contratosAsignados}{' '}
                                        no asignados
                                    </div>
                                </div>
                            </div>
                        </div>
                        {scoringTable && (
                            <ScoringTable
                                dealerCodeVWF={dealerCodeVWF}
                                cookies={cookies}
                                dataTodosLosVencimientos={
                                    dataTodosLosVencimientos
                                }
                                dataVencimientosAsignados={
                                    dataVencimientosAsignados
                                }
                                setDataTodosLosVencimientos={
                                    setDataTodosLosVencimientos
                                }
                                setDataVencimientosAsignados={
                                    setDataVencimientosAsignados
                                }
                                optSelectMarca={optSelectMarca}
                                setTitleText={setTitleText}
                                titleText={titleText}
                                matrixData={matrixData}
                                matrixContracts={matrixContracts}
                                setMatrixContracts={setMatrixContracts}
                                filtersApplied={filtersApplied}
                                setFiltersApplied={setFiltersApplied}
                                user={user}
                                getTableDataAsignados={getTableDataAsignados}
                                onExportExcel={exportVencimientosExcel}
                            ></ScoringTable>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withCookies(withRouter(Scoring));
